var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Background",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.74 24.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-lens-1 {\n        fill: rgb(265,265,265, 0.7) !important;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-lens-1",
    d: "M24.31,22.24l-6.02-6.02c2.99-4,2.63-9.65-.97-13.24C15.33.98,12.56-.1,9.76,0c-2.85.11-5.46,1.36-7.33,3.53-3.22,3.73-3.25,9.39-.07,13.15,1.8,2.13,4.32,3.41,7.09,3.6,2.45.17,4.82-.53,6.75-1.98l6.02,6.02c.28.28.65.43,1.04.43s.76-.15,1.04-.43c.57-.58.57-1.51,0-2.09ZM4.73,14.91c-2.39-2.71-2.39-6.79,0-9.5,1.37-1.56,3.35-2.45,5.41-2.45s4.04.89,5.41,2.45c2.39,2.71,2.39,6.79,0,9.5h0c-1.37,1.56-3.35,2.45-5.41,2.45s-4.04-.89-5.41-2.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon_view.b4590c80c61c5f06be5b339b543b89a1.svg";
export { ForwardRef as ReactComponent };